import React from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import AppBar from "src/components/AppBar/AppBar";
import { IconName } from "src/components/Icon/Icon";
import * as S from "../../constants/StringConstants";

import { get } from "lodash";
import DisTable from "src/components/TableV2/Table";
import { IApplicationStatus } from "src/store/models/application.model";
import { fetchStatusHistory } from "src/store/reducers/applicationBuilder";
import { formatCADateTime } from "../CampaignDetail/utils";
import "./StatusHistory.scss";

const columns = [
  { key: "status", title: S.APP_STATUS_HISTORY_STATUS, style: { width: "33%" } },
  { key: "changedBy", title: S.APP_STATUS_HISTORY_CHANGED_BY, style: { width: "33%" } },
  {
    key: "changed",
    title: S.APP_STATUS_HISTORY_CHANGED_DATE,
    style: { width: "33%" },
    render: item => formatCADateTime(item.changed),
  },
];

const StatusHistory = () => {
  const { appID } = useParams<{ appID: string; reqID: string }>();
  const dispatch = useDispatch();
  const history = useHistory();
  return (
    <div className="table-view-v2__content">
      <div className="status-history-header">
        <AppBar icon={IconName.Applications} title={S.APP_STATUS_HISTORY_TITLE} />
      </div>
      <DisTable<IApplicationStatus>
        columns={columns}
        initialState={{}}
        isPaginated={false}
        onRowClick={(data: IApplicationStatus) => {}}
        onUpdate={async ({ page, rows, sort, query }) => {
          const result: any = await dispatch(fetchStatusHistory(appID));
          const data = get(result, "value.data", []) as IApplicationStatus[];
          return {
            total: data.length,
            data: data,
          };
        }}></DisTable>
      <div className="app-builder__action_buttons mt-5">
        <button type="button" className="button-v2 button-v2__secondary" onClick={() => history.goBack()}>
          {S.T_BUTTON}
        </button>
      </div>
    </div>
  );
};

export default StatusHistory;
